import helpers from '../../helpers'
import { availableLottoOnStorage } from '../../api/balance'

export default {
  'entityName': 'response_has_drug',
  id: ['request_id', 'drug_id', 'lotto'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'request_id',
    'descending': true
  },
  'fields': [
    {
      'value': 'drug_id',
      'reference': 'request_has_drug',
      'id': 'drug_id',
      'text': 'Drug',
      'type': 'autocomplete',
      'title': 'drug.name',
      subtitle: ({drug}) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      'table': {
        'text': 'name'
      },
      render: ({ drug }) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      'filter': drug => ({ request_id: drug.request_id }),
      'validators': [
        'required'
      ]
    },
    {
      'value': '_n_requested',
      'text': 'N. requested',
      'type': 'text',
      readonly: true,
      deps: ['drug_id'],
      default: (item, args, selected) => selected ? selected.n_pieces : item.n_pieces
    },
    {
      value: '_packaging',
      deps: ['drug_id'],
      visible: false,
      default: (item, args, selected) => selected && selected.drug.packaging
    },
    {
      value: '_serials_available',
      deps: ['drug_id'],
      visible: false,
      default: (item, args, selected) => selected && selected.drug.serials_available      
    },
    {
      "value": "lotto",
      "text": "Batch number",
      list: availableLottoOnStorage,
      title: 'lotto',
      id: 'lotto',
      subtitle: item => `${item.n_pieces} / ${item.expiration}`,
      "type": "combobox",
      "table": {
          "sortable": true,
          "filter": true
      },
      deps: ['_packaging'],
      visible: item => item._packaging !== 'Labels' && (item.drug ? item.drug.packaging !== 'Labels' : true),
      "validators": [
          "required",
          "nowhitespace"
      ]
    },
    {
      full: true,
      visible: false,
      value: '_lotto_exists',
      deps: ['lotto', '_packaging'],
      default: (item, args, selected) => selected ? true : false
    },
    {
        "value": "expiration",
        "text": "Expiration",
        "type": "date", //issue 257 services cambiato datetime con date
        min: true,
        default: (item, args, selected) => selected && selected.expiration,
        deps: ['_packaging', 'lotto'],
        readonly: item => item._lotto_exists,
        visible: item => item._packaging !== 'Labels' && (item.drug ? item.drug.packaging !== 'Labels' : true),
        "table": {
            "sortable": true,
            "filter": false
        },
        'validators': ['required']
    },
    {
      text: 'Serials in storage',
      value: '_original_serials',
      deps: ['lotto', '_lotto_exists' ,'_serials_available'],
      visible: item => item._serials_available && item.lotto && item._lotto_exists,
      readonly: true,
      default: (entity, args, selected) => selected?.serials
    },    
    {
      full: true,
      value: '_serials',
      text: "Serial numbers",
      type: 'textarea',
      deps: ['_original_serials'],
      default: (item) => item.serials,
      visible: item =>  item._serials_available,
      validators: ['serials', 'required',
      (_field, value, item) => {
        if (item._original_serials ) {
          const ret = helpers.serialsAvailability(item._original_serials, value)
          if (ret.length) {
            const alreadyAvailable = helpers.compatSerials(ret)
            return `Serials ${alreadyAvailable} already in storage`
          }

        }
        if (helpers.nSerials(value) > item._n_requested) return `N.items has to be <= N.requested (${item._n_requested})`

        return true
      },
    ]
    },
    {
      "value": "serials",
      text: "Serial numbers",
      "type": "hidden",
      table: true,
      deps: ['_serials'],
      default: item => helpers.compatSerials(helpers.explodeSerials(item._serials)),
    },
    {
      "value": "n_pieces",
      "text": "Quantity",
      full: true,
      "type": "number",
      table: {
        sortable: true
      },
      "deps": ['_serials', 'drug_id'],
      default: item => item._serials && helpers.nSerials(item._serials),
      validators: ['required','number', (field, value) => value > 0 || `Only values greater than zero are allowed.`],
      readonly: item => !!item._serials || !!item._serials_available,
    }
  ],
  "actions": ['remove']
}
